import React from 'react';
import { howItWorks } from '../data/mock';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const HowItWorksSection = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-gradient-to-b from-violet-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-fuchsia-500 font-semibold text-sm uppercase tracking-wide">
            How It Works
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mt-2 mb-4">
            Getting started is easy
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            No complicated onboarding. No long-term commitments. Just clear, nurse-led support when you need it.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-6">
          {howItWorks.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector line */}
              {index < howItWorks.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-violet-300 to-fuchsia-300"></div>
              )}
              
              <div className="bg-white rounded-3xl p-8 shadow-sm border border-violet-100 hover:shadow-lg hover:border-violet-200 transition-all relative z-10">
                <div className="w-16 h-16 btn-nursebloc rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                  <span className="text-2xl font-bold text-white">{step.step}</span>
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button 
            size="lg"
            className="btn-nursebloc px-8 py-6 rounded-full text-lg font-semibold shadow-lg group"
            onClick={() => scrollToSection('contact')}
          >
            Schedule Your Free Consultation
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
          <p className="text-sm text-gray-500 mt-2 text-center">Free 15–30 minute virtual consult with a real nurse</p>
          <p className="text-xs text-gray-400 mt-1 text-center">Private • No pressure • No obligation</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
